import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { KsefSendParametersQuery, KsefSendParametersQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(KsefSendParametersQuery)
@Wrapper(KsefSendParametersQueryHandlerBase)
export class KsefSendParametersQueryHandler {
    public constructor(
        http: Http
    ) { }
}
